// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"94d82fb1","77":"28942140","115":"a66fb7a3","222":"a8d73abf","280":"01391eb4","354":"92c158cb","444":"f9db5d39","510":"321a5437","563":"cbb2f55a","567":"e7f4c384","860":"d0d47938","928":"d979bf35"}[chunkId] + ".chunk.js";
};